import {computed} from "mobx";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {GameCompetitorDomainModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-domain-model";
import {LineupsDomainModel} from "../../../domain/yard/lineups/lineups-domain-model";
import {LineupsMemberDomainModel} from "../../../domain/yard/lineups/lineups-member/lineups-member-domain-model";

export class CompetitorPlayerStatsModuleCompetitorViewModel extends CompetitorViewModel {
  domainModel: GameCompetitorDomainModel;

  constructor(model: GameCompetitorDomainModel) {
    super(model);

    this.domainModel = model;
  }

  @computed get statsCategory(): LineupsDomainModel {
    return this.domainModel.lineups?.statsCategory;
  }

  @computed get members(): Array<LineupsMemberDomainModel> {
    return this.domainModel.lineups?.members;
  }
}
